"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageEnquiriesByUserId = exports.getPackageEnquiries = void 0;
const getPackageEnquiries = async (supabase) => {
    const { data, error } = await supabase
        .from("package_enquiries")
        .select(`*,
      hotel:hotels!hotel_id(*),
      departure_airport:areas!departure_airport(*),
      arrival_airport:areas!arrival_airport(*),
      agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*))`)
        .order("created_at", { ascending: false });
    if (!error) {
        const { data: courses, error: coursesError } = await supabase
            .from("courses")
            .select(`id, name`);
        const packages = data;
        return packages.map((pkg) => {
            return {
                ...pkg,
                courses: courses?.filter((course) => {
                    return pkg.courses.includes(course.id);
                }),
            };
        });
    }
    return error;
};
exports.getPackageEnquiries = getPackageEnquiries;
const getPackageEnquiriesByUserId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("package_enquiries")
        .select(`*,
    agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*))`)
        .eq("client_id", id)
        .order("created_at", { ascending: false });
    if (!error) {
        return data;
    }
    return error;
};
exports.getPackageEnquiriesByUserId = getPackageEnquiriesByUserId;
